module.exports = {
	"articleTitle1": "Raising the bar: CCRB looks to improve its facilities",
	"catImage": "orangestar.png",
	"totalCats": 2,
	"name": "Central Campus Recreational Building (CCRB)",
	"articleLink1": "https://www.michigandaily.com/news/rec-sports-secondary",
	"articleLink2": "https://www.michigandaily.com/content/2009-04-15/ccrb-out-shape",
	"articleSnippet1": "Dec 1, 2014 ... A maize banner hung next to the entrance of the Central Campus Recreation \nBuilding for the final week of August with these words written in ...",
	"articleSnippet2": "Apr 14, 2009 ... When LSA junior Jeff Kendall first stepped foot in the Central Campus \nRecreational Building (CCRB), his first impression was that the facilities ...",
	"totalMisc": 0,
	"articleTitle2": "The CCRB is out of shape",
	"address": "401 Washtenaw Ave. Ann Arbor, MI",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/leg/imagecache/fullnode/max.NEW_.ccrb_.3-31-090004.jpg",
			"author": "File Photo",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.277824,
		"lng": -83.732665
	},
	"tips": [
		{
			"text": "Take advantage of racketball courts.",
			"person": "Bob Lesser"
		}
	],
	"bathroomrating": [],
	"categories": {
		"pickupsports": 1,
		"fitnesscenter": 1,
		"location": 1,
		"recarea": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/ccrb.json
// module id = 845
// module chunks = 0